export const PH_MOBILE_PATTERN = '^09[0-9]{2}-[0-9]{3}-[0-9]{4}$';
const PH_MOBILE_REGEX = new RegExp(PH_MOBILE_PATTERN);

export function formatPhMobileInput(value) {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 4) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 4)}-${digits.slice(4)}`;
  return `${digits.slice(0, 4)}-${digits.slice(4, 7)}-${digits.slice(7)}`;
}

export function isValidPhMobile(value) {
  return PH_MOBILE_REGEX.test(value);
}
